<template>
        <div class="blog-detail-wrapper"  >
          <b-row>
            <!-- blogs -->
            <b-col cols="12">
              <b-card>
                <b-media no-body>
                  <b-media-aside
                    vertical-align="center"
                    class="mr-50"
                  >
                    <b-avatar
                      href="javascript:void(0)"
                      size="24"
                      :src="item.user.profile_image_path"
                    />
                  </b-media-aside>
                  <b-media-aside>
                    <h6 class="font-weight-bolder">
                     {{item.name}}
                    </h6>
                  </b-media-aside>
                  <b-media-body>
                    <small class="text-muted mr-50">by</small>
                    <small>
                      <b-link class="text-body">{{item.user.full_name}}</b-link>
                    </small>
                    <span class="text-muted ml-75 mr-50">|</span>
                    <small class="text-muted">{{item.created_at}}</small>
                  </b-media-body>
                </b-media>
              </b-card>
            </b-col>
            <!--/ blogs -->
            <!-- <div class="row"> -->
              <div class="col-md-12  overflow-auto">
                <b-table :stacked="($mobile==1)" 
                  ref="table"
                  class="vuetable"
                  sort-by="id"
                  sort-desc.sync="false"
                  :fields="bootstrapTable.fields"
                  :items="dataProvider"
                >
                  <template #cell(answers)="data">
                    <b-button
                      v-b-modal.modal-scrollable
                      variant="outline-info"
                      @click="activity_answer_modal(data.item)"
                    >
                      {{ $t("activities.show") }}
                    </b-button>
                  </template>
                  <template #cell(edit)="data">
                    <button
                      class="btn btn-icon btn-warning btn-sm"
                      @click="editAnswer(data)"
                      v-if="(!data.item.grade && checkTime(item))"
                    >
                      <i class="fa fa-edit" />
                    </button>
                  </template>

                </b-table>
                          <b-spinner   v-if="load" type="grow" label="Loading..."  class="loading" />
                <!-- end of table -->
              </div>
              <!-- end of col -->
            <!-- </div> -->

            <!-- Leave a Blog Comment -->
            <b-col
              cols="12"
              class="mt-2"
              v-if="(totalAnswers < 3 && checkTime(item))|| (edit==true && checkTime(item))"
            >
              <h6 class="section-label">
                {{$t('activities.solve_your_homework')}}
              </h6>
              <b-card >
                <validation-observer ref="registerForm" #default="{ invalid }">
                  <b-form>
                    <b-row>
                      <b-col cols="12" v-for="(question,index) in questions" :key="index">
                          <b-card-text>
                          {{++index +'-'+ question.question}}
                          </b-card-text>
                          <validation-provider
                            #default="{ errors }"
                            :name="$t('activities.answer')"
                            rules="required"
                          >    
                          <ckeditor
                            :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                            v-model="question.answer"
                            :placeholder="$t('activities.answer')"
                            :state="errors.length > 0 ? false : null"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                          </validation-provider>   
                      </b-col>
                      <b-col cols="12">
                        <b-button
                          :disabled="invalid"
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="primary"
                          @click="submit()"
                        >
                          {{$t('site.add')}}
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-form>
                </validation-observer>
              </b-card>
            </b-col>
            <!--/ Leave a Blog Comment -->
          </b-row>
          <!--/ blogs -->

              <b-modal
      id="modal-scrollable"
      scrollable
      :title="$t('activities.questions')"
      ok-only
      :ok-title="$t('activities.done')"
      size="lg"
    >
          <b-row >
            <b-col lg="12">
              <b-form v-for="(question,k) in  questions_with_answers" :key="k">
                <b-col
                  id="blogComment"
                  cols="12"
                  class="mt-2"
                >
                    <b-card>
                      <b-media no-body>
                        <b-media-aside class="mr-75">
                          <!-- <b-avatar
                            :src="answer.user.profile_image_path"
                            size="38"
                          /> -->
                        </b-media-aside>
                        <b-media-body>
                          <h4 class="font-weight-bolder mb-25">
                            {{++k +'-'+question.question}}
                          </h4>
                          <b-card-text
                          v-html="question.answer"
                          >
                          </b-card-text>
                        </b-media-body>
                      </b-media>
                    </b-card>
                </b-col>
              </b-form>
            </b-col>
          </b-row>
    </b-modal>
        </div>

</template>

<script>
import Ripple from 'vue-ripple-directive';
import ActivitiesController from '@/Controllers/ActivitiesController';
import Auth from "@/Apis/Auth";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
  props: ["item"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    },
  data() {
    return {
      file: {},
      bootstrapTable: {
        selected: [],
        selectMode: 'multi',
        fields: [
          {
            key: 'grade', label: this.$i18n.t('activities.grade'), sortable: true, sortDirection: 'desc',
          },
          {
            key: 'answers', label: this.$i18n.t('activities.answers'), sortable: true, sortDirection: 'desc',
          },
          { key: 'edit', label: this.$i18n.t('site.action'), sortable: false },
        ],
      },
      // newAnswer:{},
      questions_with_answers:[],
      questions:[],
      user:{},
      load: false,
      totalAnswers:0,
      data: {},
      edit:false
    }
  },
  directives: {
    Ripple,
    },
  async created(){
    this.user = Auth.USER;
    this.prepare_questions();
  },
  methods:{
    checkTime(item) {
      const check = new Date();
      console.log(item.start_date);

      const stDate = new Date(item.start_date);
      const enDate = new Date(item.end_date);
      console.log(stDate,enDate)
      if (
        check.getTime() <= enDate.getTime() &&
        check.getTime() >= stDate.getTime()
      )
        return true;
      // && datanow <= enDate) return true;
      return false;
    },
    activity_answer_modal(item){
      this.questions_with_answers=item.questions;
    },
    prepare_questions(){
      this.questions=[];
          this.$props.item.questions.map((el)=>{
            this.questions.push({
              question:el.question,
              activity_question_id:el.id,
              answer:'',
              user_id:this.user.id,
            });
          })
    },
    editAnswer(data){
      this.edit=true;
      window.scrollTo(0, 500);
      this.questions=data.item.questions;
      console.log(this.questions);

    },
    async dataProvider() {
      this.load = true
      let questions_ids=this.$props.item.questions.map((el)=>{
        return el.id;
      });
      const data = await new ActivitiesController().GetHomeWorkAnswers({with:'question',questions_ids:questions_ids})
      this.data = this.handleDataTableData(data);
      this.load = false
      return this.data;
    },
    handleDataTableData(data){
      let res=[];
      for(let i=1;i<=3;i++){
        let correct_flag=0;
        let mygrade=0;
        const results=data.filter((element)=>{
            return element.answer_number==i;
        });
        if(results.length>0){
        let questions=[];
        results.map((el)=>{
            if(el.grade!=null){
              correct_flag=1;
              mygrade+=el.grade;
            }
            questions.push({
              question:el.question.question,
              answer:el.answer,
              id:el.id,
              activity_question_id:el.activity_question_id,
              user_id:this.user.id,
              answer_number:el.answer_number
            })
        })
        res.push({
          grade:correct_flag==0?null:((mygrade/results.length)*(this.$props.item.grade/100)).toFixed(2),
          questions:questions,
        })
        }
      }
      this.totalAnswers=res.length;
      return res;
    },
    async submit(){
      console.log(this.dataHandle());
      let ret = await new ActivitiesController().activity_answer(this.dataHandle());
      if(ret){
        this.load=true;
        await this.dataProvider();
        window.scrollTo(500,0);
        this.$refs.table.refresh();
        this.edit=false;
        this.prepare_questions();
        console.log(this.$props.item.questions);
        this.load=false;
      }
    },
    dataHandle(){
      let data=[];
      if(this.edit==false){
        this.questions.forEach((element) => {
          element.answer_number = this.totalAnswers+1
          delete element['question'];
        });
      }else{
        this.questions.forEach((element) => {
          delete element['question'];
        });
      }
      data=this.questions;
      
      return {data:data,edit:this.edit,user:this.user,activity:this.$props.item};
        
    }

  },

}
</script>
<style>

</style>